<template>
  <div id="app">
    <router-view />
    <!-- vamos  a programar -->
    <!-- //bahhashas -->
    <Footer v-if="isUserLoggedIn" class="footer mx-2"/>

  </div>
</template>

<script>
import Footer from '@/components/ModSeleccion/Footer/Footer.vue'

export default {
  name: "SolimanoextranetApp",
  components: {
    Footer,

  },
  data() {
    return {

    };
  },

  mounted() {
   
  },
  computed: {
    isUserLoggedIn() {
      return localStorage.getItem('userId') !== null && localStorage.getItem('userId') !== '';
    } },
     methods: {
      
   
     },
};
</script>

<style scoped>


/* #app {
background:#fffafa;
display: flex;
  flex-direction: column;
  min-height: 100vh;
} */


.footer {
  margin-top: auto;
  padding-bottom: 1%;
}

.modal{
  background: rgb(170, 115, 222);
}

/*Còdigo opcional - Fondo de la pàgina*/

/*---*/

</style>
